export default __webpack_public_path__ + "static/media/blueAddNew.abc59213.svg";